import { Backdrop } from '@mui/material';
import { BrandLoader } from './BrandLoader';

export const CentralizedAnimatedLoader = ({ backdrop }: { backdrop?: boolean }) => (
    <Backdrop open={true} sx={{ zIndex: 999, background: !backdrop ? 'unset' : undefined }}>
        <BrandLoader width={80} />
    </Backdrop>
);
